import React from 'react';
import Modal from 'react-bootstrap/Modal';

interface InfosecProps {
    onHide(): void;
    show: boolean;
    sessions: string[];
}
const bootcampStyle = {
    '.bootcamp-schedule-view': { listStyleType: 'none', padding: '20px' },
    '.bootcamp-schedule-view li': {
        borderBottom: '1px solid #bbbcbc',
        marginBottom: '5px',
        paddingBottom: '5px',
    },
    '.bootcamp-schedule-view li:nth-of-type(10)': { borderBottom: 'none' },
    '.bootcamp-schedule-view li p': {
        fontFamily: 'Helvetica,Arial,sans-serif',
        fontWeight: 700,
        lineHeight: '1.7em',
        marginBottom: '0',
    },
};
const InfoSecModal: React.FC<InfosecProps> = ({ onHide, show, sessions }) => {
    return (
        <>
            <Modal
                className="ed-modal hidden-infosec-modal"
                contentClassName="ed-container"
                dialogClassName="ed-modal-content ed-animate-zoom ed-card-8 ed-round-large ed-padding"
                onHide={() => {
                    onHide();
                }}
                scrollable
                show={show}
            >
                <Modal.Body>
                    <div className="ed-container">
                        <p className="ed-container ed-padding ed-mod-s1 ed-mod-font">
                            <span id="sp_title">Boot Camp Session Dates:</span>
                        </p>
                        <p className="ed-mod-set">
                            The following dates are available for this boot camp. Once you register, our enrollment team
                            will contact you to confirm your session dates.
                        </p>
                        <div id="infoSecBootcampSessionDates" style={{ height: '450px' }}>
                            <ul id="bootcamp-schedule-view" style={bootcampStyle['.bootcamp-schedule-view']}>
                                <h5>
                                    {sessions.map((session, i) => (
                                        <li style={bootcampStyle['.bootcamp-schedule-view li']} key={i}>
                                            <p style={bootcampStyle['.bootcamp-schedule-view li p']}>{session}</p>
                                        </li>
                                    ))}
                                </h5>
                            </ul>
                        </div>
                        <button
                            className="ed-btn ed-green ed-round-medium ed-ripple ed-mod-s1-btn"
                            onClick={() => {
                                onHide();
                            }}
                        >
                            Close
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export { InfoSecModal };
